import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PI } from '../../constants-types';
import { OneSchemaUserJwtClaims } from '../interfaces/one-schema-user-jwt-claims';

@Injectable({
    providedIn: 'root'
})
export class DataImportRepositoryService {
    constructor(private http: HttpClient) {}

    fetchUserJwt(claims: OneSchemaUserJwtClaims): Observable<string> {
        return this.http.post(
            this.dataImportApiEndpoint('/generatejwt'),
            claims,
            { responseType: 'text' }
        );
    }

    private dataImportApiEndpoint(endpoint: string): string {
        let baseApi = PI?.appSettings?.dataImportApiUrl ?? '';
        baseApi = baseApi.replace(/\/$/, '').concat('/');
        endpoint = endpoint.replace(/(^\/{0,2})|(\/{0,2}$)/g, '');

        return baseApi.concat(`api/v5/${endpoint}`);
    }
}
